import { Container, TopLevelContainer, Column, Row } from '@xo-union/tk-component-grid';
import Icon from '@xo-union/tk-component-icons';
import React from 'react';

import styles from './header.scss';

interface Props {
  className?: string;
  children?: React.ReactNode | React.ReactNode[];
  title?: string;
  backText?: string;
  onBack?: () => void;
}

export const FullScreenModalHeader: React.FC<Props> = ({ className = '', children, title, backText, onBack }) => {
  if (children) {
    return <Container className={`${styles.fullScreenModalHeader} ${className}`}>{children}</Container>;
  }

  return (
    <TopLevelContainer>
      <Container className={`${styles.fullScreenModalHeader} ${className}`}>
        <Row>
          <Column xs="7" md="4" lg="5">
            <div className={styles.backArrow} onClick={onBack}>
              <Icon name="back" size="md" />
              {backText && <span>{backText}</span>}
            </div>
            <div className={styles.pageTitle}>{title}</div>
          </Column>
        </Row>
      </Container>
    </TopLevelContainer>
  );
};

export default FullScreenModalHeader;
